import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "ln-icon-success-tick",
  "use": "ln-icon-success-tick-usage",
  "viewBox": "0 0 35 35",
  "content": "<symbol viewBox=\"0 0 35 35\" id=\"ln-icon-success-tick\"><defs><circle id=\"ln-icon-success-tick_a\" cx=\"17.5\" cy=\"17.5\" r=\"14\" /></defs><g fill=\"none\" fill-rule=\"evenodd\"><circle fill=\"#FFFFFF\" cx=\"17.5\" cy=\"17.5\" r=\"17.5\" /><use fill=\"#2AA742\" xlink:href=\"#ln-icon-success-tick_a\" /><circle stroke=\"#2AA742\" stroke-width=\".7\" cx=\"17.5\" cy=\"17.5\" r=\"14.35\" /><path d=\"M12.9924621,18.5167253 C12.5824116,18.1061076 11.9175884,18.1061076 11.5075379,18.5167253 C11.0974874,18.9273429 11.0974874,19.5930857 11.5075379,20.0037033 L13.9110319,22.4105217 C14.7668903,23.2675638 16.1265637,23.1917544 16.8682264,22.2368691 L23.5788198,13.5970299 C23.9348434,13.1386522 23.8523822,12.4780504 23.3946376,12.1215344 C22.9368931,11.7650185 22.2772037,11.8475937 21.9211802,12.3059714 L15.3014142,20.828871 L12.9924621,18.5167253 Z\" fill=\"#FFFFFF\" fill-rule=\"nonzero\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ln-icon-success-tick.svg
// module id = 1175
// module chunks = 0